/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { vappContainer } from '@/application';
import { BreadcrumbService } from '@/services/breadcrumbService';
import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { toHeaderCase } from 'js-convert-case';
import { editProfile } from '../../config/editProfile.config';
import { error } from '../../config/error.config';
import { featuresSection } from '../../config/featuresSection.config';
import { formData } from '../../config/formData.config';
import { header } from '../../config/header.config';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator';
import { loading } from '../../config/loading.config';
import { notifications } from '../../config/notifications.config';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { rightFaqConfig } from '../../config/right-faq-block.config';
import { GET_LIST_OF_CITIES, GET_LIST_OF_PARISH } from '../../api/graphql';
import { apiConfig } from '@/config/apiConfig';

export interface IGetFormDataMethods extends IPluginMethodMap {
  getFormData(args?: any): any;
}

const getBreadcrumbService = () => {
  return vappContainer.get<BreadcrumbService>(BreadcrumbService.displayName);
};
const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class GetFormDataService implements IAgentPlugin {
  readonly methods: IGetFormDataMethods;

  constructor() {
    this.methods = {
      getFormData: this.getProps.bind(this),
    };
  }
  async _getdata() {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    try {
      if (client) {
        console.log(client);
        const res = await client.query(GET_LIST_OF_PARISH, {});
        console.log('ress->', res);
        return res?.data?.getListOfParish || ['hii', 'hello'];
      }
    } catch (err: any) {
      console.log(err);
      throw err;
    }
  }
  // async _getcitydata() {
  //   let gql = Graphql.withBaseUrl(apiConfig.gql.url);
  //   // const token = getToken();
  //   const token = loginSrv()?.getToken();
  //   if (token) {
  //     gql = gql.withHeaders({
  //       authentication: token,
  //     });
  //   }
  //   const client = gql.getClient();

  //   try {
  //     if (client) {
  //       console.log(client);
  //       const res1 = await client.query(GET_LIST_OF_CITIES, {
  //           parish : "Hanover"
  //       });
  //       console.log('cityress->', res1);
  //       return res1?.data?.getListOfCities || ['hii','hello'];

  //     }
  //   } catch (err: any) {
  //     console.log(err);
  //     throw err;
  //   }
  // }

  _getModifiedField(data: any) {
    // data = this._getdata();
    console.log('ddtttaa', data);
    let formFields = {};
    // data=['a','b','c'];
    let _data: any[] =
      data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any, index: number) => {
        return {
          label: item,
          value: item,
        };
      });
    console.log('_data', _data);
    if (_data) {
      formFields = formData && {
        ...formData,
        fields: formData.fields.map((item: any) => {
          if (item.type === 'select' && item.compProps.id === 'state') {
            return {
              ...item,
              compProps: {
                ...item?.compProps,
                options: _data,
              },
            };
          } else {
            return { ...item };
          }
        }),
      };
      console.log('formFields', formFields);
      // console.log("helloo",this._getdata());
      //   return formFields;
    }
    // let _cityData: any[] =
    //   citydata &&
    //   Array.isArray(citydata) &&
    //   citydata.length > 0 &&
    //   citydata.map((item: any, index: number) => {
    //     return {
    //       label: item,
    //       value: item,
    //     };
    //   });
    // console.log('_citydata', _cityData);
    // if (_cityData) {
    //   formFields = formData && {
    //     ...formData,
    //     fields: formData.fields.map((item: any) => {
    //       if (item.type === 'select' && item.compProps.id === 'city') {
    //         return {
    //           ...item,
    //           compProps: {
    //             ...item?.compProps,
    //             options: _cityData,
    //           },
    //         };
    //       } else if(item.type === 'select' && item.compProps.id === 'state') {
    //         return {
    //             ...item,
    //             compProps: {
    //               ...item?.compProps,
    //               options: _data,
    //             },
    //     }}
    //     else{
    //           return { ...item };

    //       }
    //     }),
    //   };
    //   console.log('formFields', formFields);
    //   // console.log("helloo",this._getdata());
    // }
    return formFields;
  }

  private getOrgListItems(res: any) {
    let _temp = [];
    _temp = featuresSection?.orgListItems?.map((item) => {
      if (item?.title === 'Company Registration Number') {
        return {
          ...item,
          subTitle: res?.cNumber ? `${res?.cNumber}` : '-',
        };
      }

      if (item?.title === 'Address') {
        return {
          ...item,
          subTitle: res?.address ? `${res?.address}` : '-',
        };
      }
      if (item?.title === 'City/Town') {
        return {
          ...item,
          subTitle: res?.city ?? '-',
        };
      }

      if (item?.title === 'Country') {
        return {
          ...item,
          subTitle: '-',
          flag: res?.country,
        };
      }
      if (item?.title === 'Email') {
        return {
          ...item,
          subTitle: res?.email ?? '-',
        };
      }
      if (item?.title === 'Phone Number') {
        return {
          ...item,
          subTitle: res?.telephone ?? '-',
        };
      }
      if (item?.title === 'Website') {
        return {
          ...item,
          subTitle: res?.website ?? '-',
        };
      }
    });
    return _temp;
  }

  private getListItems(res: any) {
    let _temp = [];
    _temp = featuresSection?.listItems?.map((item) => {
      if (item?.title === 'Business Name') {
        return {
          ...item,
          subTitle: res?.businessName
            ? `${toHeaderCase(res?.businessName)}`
            : '-',
        };
      }

      if (item?.title === 'Company Registration No') {
        return {
          ...item,
          subTitle: res?.companyRegNo ?? '-',
        };
      }

      if (item?.title === 'Status') {
        return {
          ...item,
          subTitle: res?.companyStatus ?? 'Under Review',
        };
      }
    });
    return _temp;
  }

  private getDirectorData = (res: any) => {
    let _temp = [];
    _temp = res?.map((item: any, key: number) => {
      return {
        title: `Director ${key + 1}`,
        subTitle: `${toHeaderCase(
          item?.directorFirstName ?? ''
        )} ${toHeaderCase(item?.directorMiddleName ?? '')} ${toHeaderCase(
          item?.directorLastName ?? ''
        )}`,
      };
    });
    return _temp;
  };
  private getCompanyData = (res: any) => {
    let _temp = [];
    console.log('onboraddd', res);
    _temp = featuresSection?.companyListItems?.map((item) => {
      if (item?.title === 'Street 1') {
        return {
          ...item,
          subTitle: res?.address1 ? `${res?.address1}` : '-',
        };
      }
      if (item?.title === 'Street 2') {
        return {
          ...item,
          subTitle: res?.address2 ? `${res?.address2}` : '-',
        };
      }
      if (item?.title === 'Incorporation Date') {
        return {
          ...item,
          subTitle: res?.incorporationDate ?? '-',
        };
      }
      if (item?.title === 'Nature of Business') {
        return {
          ...item,
          subTitle: res?.natureOfBusiness ? `${res?.natureOfBusiness}` : '-',
        };
      }
      if (item?.title === 'Parish') {
        return {
          ...item,
          subTitle: res?.parish ?? '-',
        };
      }
      if (item?.title === 'Website') {
        return {
          ...item,
          subTitle: res?.website ?? '-',
        };
      }
      if (item?.title === 'Taxpayer Registration No') {
        return {
          ...item,
          subTitle: res?.taxpayerRegNo ?? '-',
        };
      }
      if (item?.title === 'Company Type') {
        return {
          ...item,
          subTitle: res?.companyType ?? '-',
        };
      }
      if (item?.title === 'Postal Code') {
        return {
          ...item,
          subTitle: res?.postalCode ?? '-',
        };
      }
      if (item?.title === 'Street Address') {
        return {
          ...item,
          subTitle: res?.address ? `${res?.address}` : '-',
        };
      }
      if (item?.title === 'City/Town') {
        return {
          ...item,
          subTitle: res?.city ?? '-',
        };
      }
    });
    return _temp;
  };

  private format = (_res: any) => {
    console.log('onboradddd--->', _res);
    return {
      title: `${toHeaderCase(_res?.firstName ?? '')} ${toHeaderCase(
        _res?.lastName ?? ''
      )}`,
      subtitle: _res?.vuid ? `Account ID: ${_res?.vuid}` : _res?.occupation,
      heroImage: {
        image:
          _res?.image ??
          `https://ui-avatars.com/api/?name=${_res.firstName}+${_res?.lastName}&background=0D8ABC&color=fff`,
      },
      listItems: this.getListItems(_res),
      initialData: {
        firstName: _res?.firstName,
        lastName: _res?.lastName,
        image: _res?.image,
        telephone: _res?.primaryContactNo,
        address: _res?.address?.addressLine1,
        city: _res?.address?.city,
        country: _res?.address?.country,
        occupation: _res?.occupation,
      },
      statusComp: {
        title: `Review Pending`,
        statusType: 'warning',
      },
      buttons: featuresSection?.buttons,
      accordionItems: [
        {
          type: 'multi-col-list',
          numberOfColumns: '3',
          title: 'Company Details',
          data: this.getCompanyData(_res),
        },
        {
          type: 'multi-col-list',
          numberOfColumns: '3',
          title: 'Directors List',
          data: this.getDirectorData(_res?.directors),
        },
      ],
      organizationProfile: {
        title: _res?.org?.name,
        subtitle: _res?.org?.description,
        heroImage: {
          image:
            _res?.org?.logo ??
            `https://ui-avatars.com/api/?name=${_res.org?.name}&background=0D8ABC&color=fff`,
        },
        listItems: this.getOrgListItems(_res?.org),
        buttons: featuresSection?.buttons,
        formDefaultData: {
          name: _res?.org?.name,
          description: _res?.org?.description,
          image: _res?.org?.logo,
          address: _res?.org?.address?.addressLine1,
          country: _res?.org?.address?.country,
          city: _res?.org?.address?.city,
          telephone: _res?.org?.primaryContactNo,
          website: _res?.org?.website,
          firstName: _res?.firstname,
          lastName: _res?.lastName,
        },
      },
    };
  };

  async getProps(args?: any) {
    const listt = await this._getdata();
    // const cityList=await this._getcitydata();
    console.log('jrammm', listt);
    // while(!listt){}
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    // const srv = getBreadcrumbService();
    // const breadcrumbItems = srv?.getBreadCrumbItems();
    console.log('find->', this.format(args));
    console.log('enteredgetformdata');
    const _role =
      userData?.currentRole ?? userData ? userData?.userRoles[0]?.name : '';
    return {
      header:
        _role === 'admin'
          ? { ...header, headerAction1: null }
          : { ...header, ...{} },
      loading: loading,
      error: error,
      notifications: notifications,
      rightBlockContent: rightFaqConfig,
      editProfile: editProfile,
      formData: this._getModifiedField(listt),
      // formData: formData,
      sampleData: this.format(
        args
          ? args
          : {
              businessName: 'bName',
              companyRegNo: '123',
              incorporationDate: '12/06/2023',
              companyType: 'public',
              address1: 'street1',
              address2: 'street2',
              city: 'city1',
              parish: 'parish3',
              postalCode: '12323',
              companyStatus: 'active',
            }
      ),
    };
  }
}
